function SecurityCtrl($scope, $timeout, $state, GeneralUtilsService) {

    $scope.frequencies = ['IMMEDIATE', 'HOURLY', 'DAILY',  'WEEKLY'];

    $scope.saveTrigger = function(trigger){
        $scope.scopeSelection.item.trigger = $scope.scopeSelection.trigger;
        if($scope.scopeSelection.trigger || trigger) {
            $scope.scopeSelection.item.alertFrequency = $scope.scopeSelection.alertFrequency;
            $scope.scopeSelection.item.addresses = $scope.scopeSelection.addresses;
        }
        $scope.$root.$emit("$closePopup","triggerSelector");
        $scope.$root.$emit("$closePopup","mailingListSelector");
    };


    $scope.editMailingList = function(item,id){
        $scope.$root.$emit("$openPopup","mailingListSelector","trigger_" + id );
        var alertFrequency = item.alertFrequency?item.alertFrequency:"HOURLY";
        var addresses = item.addresses?item.addresses:"All Admins";
        $scope.scopeSelection = {"item":item,"trigger":item.trigger,"alertFrequency":alertFrequency,"addresses":addresses};
    };

    $scope.editTrigger = function(item,id){
        $scope.$root.$emit("$openPopup","triggerSelector","trigger_" + id );

        var isQuality = item.healthType && item.healthType === 'Quality';
        var alertFrequency = item.alertFrequency ? item.alertFrequency : "HOURLY";
        var addresses = item.addresses?item.addresses:"All Admins";

        // in case of quality issues, only the mailing list can be edited by the user
        $scope.scopeSelection = {"item":item,"trigger":item.trigger,"alertFrequency":alertFrequency,"addresses":addresses,frequencyDisabled:isQuality, triggerDisabled:isQuality};
    }
}
